var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4569_10064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 40.3C38.5 19.3 32.5 12.3 22 11.3L23 19.3C25 33.8 15 31.3 15 40.3H38Z",
    fill: "#2F3233",
    stroke: "#2F3233",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 19.3C24.38 22.21 18.45 26.67 16 28.3C13 30.3 13.18 32.64 11 32.3C9.958 31.36 12.41 29.26 11 29.3C10 29.3 11.19 30.53 10 31.3C9 31.3 5.997 32.3 6 27.3C6 25.3 12 15.3 12 15.3C12 15.3 13.89 13.4 14 11.8C13.27 10.806 13.5 9.80005 13.5 8.80005C14.5 7.80005 16.5 11.3 16.5 11.3H18.5C18.5 11.3 19.28 9.30805 21 8.30005C22 8.30005 22 11.3 22 11.3L24 19.3Z",
    fill: "#2F3233",
    stroke: "#2F3233",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10.3C32.5 11.3 38.5 18.3 38 39.3H15C15 30.3 25 32.8 23 18.3",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.3C32.5 11.3 38.5 18.3 38 39.3H15C15 30.3 25 32.8 23 18.3",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 18.3C24.38 21.21 18.45 25.67 16 27.3C13 29.3 13.18 31.64 11 31.3C9.958 30.36 12.41 28.26 11 28.3C10 28.3 11.19 29.53 10 30.3C9 30.3 5.997 31.3 6 26.3C6 24.3 12 14.3 12 14.3C12 14.3 13.89 12.4 14 10.8C13.27 9.80605 13.5 8.80005 13.5 7.80005C14.5 6.80005 16.5 10.3 16.5 10.3H18.5C18.5 10.3 19.28 8.30805 21 7.30005C22 7.30005 22 10.3 22 10.3",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.3C24.38 21.21 18.45 25.67 16 27.3C13 29.3 13.18 31.64 11 31.3C9.958 30.36 12.41 28.26 11 28.3C10 28.3 11.19 29.53 10 30.3C9 30.3 5.997 31.3 6 26.3C6 24.3 12 14.3 12 14.3C12 14.3 13.89 12.4 14 10.8C13.27 9.80605 13.5 8.80005 13.5 7.80005C14.5 6.80005 16.5 10.3 16.5 10.3H18.5C18.5 10.3 19.28 8.30805 21 7.30005C22 7.30005 22 10.3 22 10.3",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 25.8C9.5 25.9327 9.44732 26.0598 9.35355 26.1536C9.25979 26.2474 9.13261 26.3 9 26.3C8.86739 26.3 8.74021 26.2474 8.64645 26.1536C8.55268 26.0598 8.5 25.9327 8.5 25.8C8.5 25.6674 8.55268 25.5403 8.64645 25.4465C8.74021 25.3527 8.86739 25.3 9 25.3C9.13261 25.3 9.25979 25.3527 9.35355 25.4465C9.44732 25.5403 9.5 25.6674 9.5 25.8Z",
    fill: "#141414",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9329 16.05C14.734 16.3945 14.4976 16.6986 14.2757 16.8953C14.0539 17.092 13.8647 17.1653 13.7499 17.099C13.6351 17.0327 13.6039 16.8322 13.6634 16.5417C13.7228 16.2512 13.868 15.8945 14.0669 15.55C14.2658 15.2055 14.5022 14.9014 14.724 14.7047C14.9459 14.5079 15.1351 14.4347 15.2499 14.501C15.3647 14.5673 15.3959 14.7677 15.3364 15.0582C15.277 15.3487 15.1318 15.7055 14.9329 16.05Z",
    fill: "#141414",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4569_10064",
    x: 4.25,
    y: 7.55005,
    width: 35.5288,
    height: 35.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4569_10064"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4569_10064",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWn);
export default __webpack_public_path__ + "static/media/wn.162ceb6ad26141ce1601dda3371acc9b.svg";
export { ForwardRef as ReactComponent };